module.exports = __webpack_public_path__ + "static/media/spacexScreen.a7c328ce.jpg";